export function fmtUsd(value: number) {
  return fmtDollarAmount(Math.abs(value))
}

export function fmtPrice(value: number) {
  const absValue = Math.abs(value)

  if (value === 0) return "$0"
  if (absValue < 0.01) return `$${value.toFixed(6)}`
  if (absValue < 1) return `$${value.toFixed(4)}`
  if (absValue < 1000) {
    return `$${value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`
  }
  return `$${value.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`
}

export function fmtPnl(value: number) {
  const sign = value > 0 ? "+" : value < 0 ? "-" : ""
  return `${sign}${fmtDollarAmount(Math.abs(value))}`
}

function fmtDollarAmount(absValue: number) {
  if (absValue === 0) return "$0.00"
  if (absValue < 0.01) return "<$0.01"
  if (absValue < 1000) {
    return `$${absValue.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`
  }
  if (absValue < 10000) {
    return `$${absValue.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })}`
  }

  const formatter = new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  })
  return `$${formatter.format(absValue)}`
}

export function fmtCompactUsd(
  value: number,
  { showSigned = true }: { showSigned?: boolean } = {}
) {
  if (!Number.isFinite(value)) return "—"
  if (value === 0) return "$0"
  const abs = Math.abs(value)
  if (abs < 0.01) {
    return `${showSigned && value < 0 ? "-" : ""}$0.01`
  }
  const formatter = new Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: abs < 10 ? 2 : 1,
  })
  return `${showSigned && value < 0 ? "-" : ""}$${formatter.format(abs)}`
}

// HL funding is an hourly rate (e.g. 0.0000125 = 0.00125%/hr).
export function fmtFundingRate(value: number) {
  if (!Number.isFinite(value)) return "—"
  const pct = value * 100
  return `${pct > 0 ? "+" : ""}${pct.toFixed(4)}%`
}
